/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

function Description({ children, className }) {
  return (
    <p className={`dtv-html5-c-detail-container__description ${className}`}>
      {children}
    </p>
  );
}

Description.defaultProps = {
  className: '',
};

Description.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default memo(Description);
